import { darken } from 'polished';
import styled, { css } from 'styled-components';

import { COLORS } from 'styles/constants';

interface ReviewContainerProps {
  ownReview: boolean;
}

export const Container = styled.div`
  width: 60%;
  margin-bottom: 10px;

  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;

  @media only screen and (max-width: 700px) {
    width: 95%;
    flex-direction: column;
    align-items: center;
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    width: 95%;
    flex-direction: column;
    align-items: center;
  }
`;

export const ReviewContainer = styled.div<ReviewContainerProps>`
  width: 40%;
  margin-bottom: 30px;
  padding: 20px;

  border-radius: 5px;
  border: 5px solid #0000;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background: ${COLORS.white};
  color: ${COLORS.darktext};

  display: flex;
  flex-direction: column;

  ${(props) =>
    props.ownReview &&
    css`
      border: 5px solid ${darken(0.05, COLORS.primary)};
    `}

  @media only screen and (max-width: 700px) {
    width: 85%;
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    font-size: 22px;
    width: 80%;
  }
`;

export const AuthorProfileButton = styled.button`
  width: fit-content;

  background: none;
  border: none;
  text-align: left;
  color: ${COLORS.primary};
  font-size: 22px;

  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }

  svg {
    margin-left: 6px;
  }
`;

export const ReviewVeredict = styled.p`
  margin: 5px 0 15px 0;

  font-size: 17px;

  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
  }
`;

export const ReviewText = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 16px;
  }

  i {
    color: #888;
  }
`;

export const DeleteReviewButton = styled.button`
  margin-top: 25px;
  padding: 15px;

  border: none;
  border-radius: 5px;
  color: #fff;
  background: ${COLORS.primary};

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NoReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin-top: 10px;

    color: ${COLORS.white};
    font-size: 20px;
  }

  @media only screen and (max-width: 900px) {
    padding: 20px;
    text-align: center;
  }
`;
